module.exports = __webpack_public_path__ + "static/paris-001-a95c387012df05bed9dbad2430c5f355.jpg";